module.exports = __webpack_public_path__ + "img/image@2x.fd09459c.png";